var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0166 3C8.8082 3 2.95792 8.6 2.95792 15.5C2.95792 22.4 8.8082 28 16.0166 28C23.225 28 29.0752 22.4 29.0752 15.5C29.0752 8.6 23.225 3 16.0166 3ZM24.3219 21.5375C22.4545 19.3625 17.9231 18.625 16.0166 18.625C14.11 18.625 9.57866 19.3625 7.71127 21.5375C6.37928 19.8625 5.56965 17.775 5.56965 15.5C5.56965 9.9875 10.2577 5.5 16.0166 5.5C21.7754 5.5 26.4635 9.9875 26.4635 15.5C26.4635 17.775 25.6539 19.8625 24.3219 21.5375ZM11.446 12.375C11.446 9.95 13.4832 8 16.0166 8C18.55 8 20.5871 9.95 20.5871 12.375C20.5871 14.8 18.55 16.75 16.0166 16.75C13.4832 16.75 11.446 14.8 11.446 12.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.c0674b25e92e23f8121cf22243ab7c8e.svg";
export { ForwardRef as ReactComponent };